import React from 'react';
import {
  ClipPath,
  Defs,
  G,
  LinearGradient,
  Path,
  Rect,
  Stop,
  Svg,
} from 'react-native-svg';

export interface LevelBadgeSvgProps {
  size?: number;
}

export const LevelBadgeSvg = ({ size = 125 }: LevelBadgeSvgProps) => {
  return (
    <Svg width={size} height={size} viewBox="0 0 125 124" fill="none">
      <G clipPath="url(#clip0_2_13911)">
        <Path
          d="M57.4062 1.40496C60.2066 -0.46646 64.7893 -0.46646 67.5897 1.40496L68.6429 2.10708C71.4433 3.97851 76.4391 4.97228 79.7418 4.31337L80.984 4.06762C84.2867 3.41141 88.521 5.16401 90.3924 7.9644L91.0946 9.01758C92.966 11.818 97.2003 14.648 100.506 15.3043L101.745 15.5527C105.051 16.2035 108.291 19.4441 108.947 22.7521L109.193 23.9944C109.852 27.297 112.682 31.5314 115.482 33.4028L116.533 34.1076C119.333 35.979 121.089 40.2107 120.43 43.516L120.184 44.7555C119.528 48.0609 120.522 53.0541 122.393 55.8545L123.095 56.9076C124.967 59.708 124.967 64.2907 123.095 67.0911L122.393 68.1443C120.522 70.9447 119.528 75.9405 120.184 79.2432L120.43 80.4854C121.089 83.7881 119.333 88.0224 116.533 89.8938L115.482 90.596C112.682 92.4674 109.852 96.7017 109.193 100.007L108.947 101.247C108.291 104.552 105.051 107.793 101.745 108.449L100.506 108.694C97.2003 109.353 92.966 112.183 91.0946 114.984L90.3924 116.034C88.5345 118.835 84.2867 120.59 80.9732 119.931L79.731 119.685C76.4283 119.029 71.4325 120.023 68.6321 121.894L67.5789 122.596C64.7785 124.468 60.1958 124.468 57.3954 122.596L56.3423 121.894C53.5419 120.023 48.5487 119.029 45.2434 119.685L44.0038 119.931C40.6985 120.59 36.4668 118.835 34.5954 116.034L33.8906 114.984C32.0192 112.183 27.7848 109.353 24.4822 108.694L23.24 108.449C19.9427 107.793 16.7021 104.552 16.0513 101.247L15.8029 100.007C15.1467 96.7017 12.3166 92.4674 9.51618 90.596L8.463 89.8938C5.66262 88.0359 3.91001 83.7881 4.56623 80.4746L4.81197 79.2324C5.47088 75.9297 4.47711 70.9339 2.60569 68.1335L1.90357 67.0803C0.0321442 64.2799 0.0321442 59.6972 1.90357 56.8968L2.60569 55.8437C4.47711 53.0541 5.47088 48.069 4.82007 44.7555L4.57433 43.516C3.91812 40.2107 5.67072 35.979 8.4711 34.1076L9.52428 33.4028C12.3247 31.5314 15.1548 27.297 15.811 23.9944L16.0594 22.7521C16.7021 19.4441 19.9427 16.2035 23.2508 15.5527L24.493 15.3043C27.7956 14.648 32.03 11.818 33.9014 9.01758L34.6062 7.9644C36.4776 5.16401 40.7093 3.41141 44.0146 4.06762L45.2542 4.31337C48.5595 4.97228 53.5527 3.97851 56.3531 2.10708L57.4062 1.40496Z"
          fill="url(#paint0_linear_2_13911)"
        />
        <Path
          d="M57.9311 4.75131L57.9307 4.75162L56.9289 5.41947L57.9311 4.75131ZM57.9311 4.75131C59.1643 3.92723 60.8184 3.49993 62.4987 3.49993C64.179 3.49993 65.8332 3.92723 67.0663 4.75132L67.0668 4.75162M57.9311 4.75131L67.0668 4.75162M67.0668 4.75162L68.0685 5.41947L67.0668 4.75162ZM80.1879 7.35986L80.1875 7.35994L79.0062 7.59364C79.006 7.59367 79.0058 7.59371 79.0056 7.59374C77.3509 7.92378 75.3073 7.83594 73.3506 7.4469C71.3939 7.05786 69.472 6.35726 68.069 5.41978L80.1879 7.35986ZM80.1879 7.35986C81.6423 7.07089 83.334 7.30913 84.8866 7.95202C86.4391 8.59491 87.8039 9.62239 88.628 10.8555L89.2959 11.8573L89.2962 11.8578M80.1879 7.35986L89.2962 11.8578M89.2962 11.8578C90.2338 13.2608 91.7412 14.6436 93.4003 15.7521C95.0592 16.8605 96.9138 17.7239 98.5697 18.0528C98.57 18.0528 98.5702 18.0529 98.5704 18.0529L99.749 18.2892L99.7507 18.2895M89.2962 11.8578L99.7507 18.2895M99.7507 18.2895C101.206 18.576 102.678 19.4419 103.866 20.6298C105.054 21.8176 105.921 23.2903 106.211 24.7471C106.211 24.7472 106.211 24.7473 106.211 24.7474L106.444 25.9292L106.445 25.93M99.7507 18.2895L106.445 25.93M106.445 25.93C106.775 27.5847 107.639 29.4387 108.748 31.0974C109.856 32.7562 111.239 34.2636 112.642 35.2012L113.641 35.8714L113.642 35.8719M106.445 25.93L113.642 35.8719M113.642 35.8719C114.875 36.6961 115.903 38.0604 116.546 39.6125C117.189 41.1646 117.428 42.8562 117.138 44.3117L117.137 44.3122M113.642 35.8719L117.137 44.3122M117.137 44.3122L116.904 45.4917C116.904 45.4917 116.904 45.4917 116.904 45.4918C116.575 47.1477 116.663 49.1913 117.053 51.1478C117.442 53.1044 118.143 55.0258 119.08 56.4288L119.748 57.4306L119.749 57.431M117.137 44.3122L119.749 57.431M119.749 57.431C120.573 58.6642 121 60.3183 121 61.9986C121 63.679 120.573 65.3331 119.749 66.5662L119.748 66.5667M119.749 57.431L119.748 66.5667M119.748 66.5667L119.08 67.5685M119.748 66.5667L119.08 67.5685M117.138 79.6882L117.137 79.6874L116.904 78.5057L117.138 79.6882ZM117.138 79.6882C117.428 81.1424 117.19 82.8339 116.546 84.3864C115.903 85.9389 114.875 87.3038 113.642 88.1279L113.92 88.5437M117.138 79.6882L113.92 88.5437M113.92 88.5437L113.642 88.128L112.642 88.7961C111.239 89.7337 109.856 91.2411 108.748 92.9002C107.639 94.5593 106.775 96.414 106.445 98.0699L106.444 98.0704M113.92 88.5437L106.444 98.0704M106.444 98.0704L106.211 99.2498M106.444 98.0704L106.211 99.2498M106.211 99.2498C106.211 99.2499 106.211 99.2499 106.211 99.25C105.922 100.705 105.054 102.178 103.866 103.366C102.678 104.554 101.206 105.421 99.75 105.71C99.75 105.71 99.75 105.711 99.7499 105.711L98.5705 105.944L98.57 105.944C96.9141 106.275 95.0593 107.139 93.4003 108.247C91.7412 109.356 90.2338 110.739 89.2962 112.142L88.628 113.142L88.6271 113.143C87.8098 114.375 86.4458 115.403 84.8903 116.046C83.335 116.689 81.6374 116.928 80.1777 116.637L80.1772 116.637L78.9955 116.404L106.211 99.2498ZM8.10153 45.4918L8.10171 45.4926C8.42761 47.1519 8.33797 49.1952 7.94786 51.1497C7.5579 53.1034 6.8574 55.02 5.91985 56.4181L8.10153 45.4918ZM8.10153 45.4918L7.86768 44.3122L7.86765 44.3121M8.10153 45.4918L7.86765 44.3121M7.86765 44.3121C7.57864 42.8563 7.81693 41.1646 8.45978 39.6124C9.10264 38.0603 10.1301 36.696 11.3633 35.8719L11.3636 35.8717M7.86765 44.3121L11.3636 35.8717M11.3636 35.8717L12.3655 35.2012C13.7685 34.2636 15.1514 32.7562 16.2599 31.0974C17.3682 29.4388 18.2317 27.5848 18.5606 25.9301C18.5606 25.9299 18.5607 25.9298 18.5607 25.9296L18.797 24.7481L18.7975 24.7454M11.3636 35.8717L18.7975 24.7454M18.7975 24.7454C19.0804 23.2895 19.9442 21.8173 21.131 20.6296C22.3177 19.442 23.7901 18.5761 25.2467 18.2895L25.2482 18.2892M18.7975 24.7454L25.2482 18.2892M25.2482 18.2892L26.4297 18.0529C26.4299 18.0529 26.43 18.0528 26.4301 18.0528C28.0849 17.724 29.9389 16.8605 31.5975 15.7521C33.2562 14.6436 34.7637 13.2608 35.7013 11.8578L36.3718 10.8558L36.372 10.8555M25.2482 18.2892L36.372 10.8555M36.372 10.8555C37.1961 9.62232 38.5604 8.59487 40.1125 7.95201C41.6646 7.30915 43.3564 7.07086 44.8122 7.35988L44.8123 7.3599M36.372 10.8555L44.8123 7.3599M44.8123 7.3599L45.9913 7.59365L44.8123 7.3599ZM119.08 67.5685C118.143 68.9715 117.442 70.8936 117.053 72.8504C116.663 74.8071 116.575 76.8507 116.904 78.5053L119.08 67.5685ZM78.9951 116.403C77.3405 116.075 75.2969 116.163 73.3402 116.553C71.3834 116.942 69.4613 117.643 68.0583 118.58L67.0565 119.248L67.056 119.249C65.8229 120.073 64.1688 120.5 62.4884 120.5C60.8081 120.5 59.154 120.073 57.9208 119.249L57.9204 119.248L56.9186 118.58C55.5156 117.643 53.5942 116.942 51.6376 116.553C49.6811 116.163 47.6375 116.075 45.9816 116.404C45.9815 116.404 45.9815 116.404 45.9814 116.404L44.802 116.637L44.8015 116.637C43.346 116.928 41.6544 116.689 40.1023 116.046C38.5502 115.403 37.1859 114.375 36.3617 113.142L36.3612 113.141L35.691 112.142L78.9951 116.403ZM26.419 105.944L25.2375 105.711L35.6905 112.141C34.7528 110.739 33.2457 109.356 31.5872 108.247C29.9285 107.139 28.0744 106.275 26.4198 105.944L26.419 105.944ZM25.2369 105.71C23.7855 105.421 22.3154 104.554 21.1288 103.366C19.9421 102.178 19.0761 100.706 18.7896 99.2506L18.7892 99.2489L18.553 98.0703C18.553 98.0701 18.5529 98.0699 18.5529 98.0697C18.224 96.4137 17.3605 94.5592 16.2522 92.9003C15.1437 91.2411 13.7608 89.7337 12.3578 88.7961L12.3574 88.7958L11.3551 88.1276L11.3542 88.127C10.1224 87.3098 9.09519 85.9458 8.45221 84.3903C7.8093 82.835 7.57086 81.1372 7.85999 79.6772L7.86001 79.6771L8.09371 78.4958C8.09374 78.4956 8.09378 78.4955 8.09381 78.4953C8.42385 76.8405 8.33601 74.7969 7.94697 72.8402C7.55793 70.8835 6.85733 68.9617 5.91985 67.5587L25.2369 105.71ZM5.91954 67.5582L5.25169 66.5564L5.25138 66.556C4.4273 65.3228 4 63.6687 4 61.9884C4 60.308 4.4273 58.6539 5.25138 57.4208L5.25169 57.4203L5.91904 56.4193L5.91954 67.5582Z"
          stroke="url(#paint1_linear_2_13911)"
        />
        <Path
          d="M62.498 112.812C90.5607 112.812 113.31 90.0625 113.31 61.9998C113.31 33.9372 90.5607 11.1879 62.498 11.1879C34.4353 11.1879 11.686 33.9372 11.686 61.9998C11.686 90.0625 34.4353 112.812 62.498 112.812Z"
          stroke="url(#paint2_linear_2_13911)"
          strokeWidth="4"
          strokeMiterlimit="10"
        />
        <Path
          d="M62.4984 107.751C87.7661 107.751 108.25 87.2678 108.25 62C108.25 36.7323 87.7661 16.2487 62.4984 16.2487C37.2306 16.2487 16.7471 36.7323 16.7471 62C16.7471 87.2678 37.2306 107.751 62.4984 107.751Z"
          fill="url(#paint3_linear_2_13911)"
        />
        <Path
          d="M62.4984 107.751C87.7661 107.751 108.25 87.2678 108.25 62C108.25 36.7323 87.7661 16.2487 62.4984 16.2487C37.2306 16.2487 16.7471 36.7323 16.7471 62C16.7471 87.2678 37.2306 107.751 62.4984 107.751Z"
          fill="#0060CC"
        />
        <Path
          d="M84.8134 102.028C78.7018 98.1666 70.7545 96.0282 62.5134 96.0282C54.2723 96.0282 46.3249 98.1666 40.2134 102.028C46.3251 105.89 54.2724 108.028 62.5134 108.028C70.7544 108.028 78.7016 105.89 84.8134 102.028Z"
          fill="url(#paint4_linear_2_13911)"
        />
        <Path
          d="M95.9697 78.5331C92.2779 79.115 88.7594 81.0346 85.1222 78.5722C88.1991 75.9603 94.071 75.9214 95.9697 78.5331Z"
          fill="#3393FF"
        />
        <Path
          d="M98.5336 71.9961C96.5434 74.3366 90.9861 76.1195 88.9275 75.0729C91.0502 72.5697 96.7661 69.8841 98.5336 71.9961Z"
          fill="#3393FF"
        />
        <Path
          d="M98.3168 65.1144C96.2887 67.9632 94.6664 71.1523 90.7542 72.0101C91.1665 68.4437 95.8359 64.1399 98.3168 65.1144Z"
          fill="#3393FF"
        />
        <Path
          d="M89.4475 71.9425C87.7359 68.8969 88.2342 64.5809 90.5402 62.0455C91.9817 64.357 91.4887 69.2064 89.4475 71.9425Z"
          fill="#3393FF"
        />
        <Path
          d="M98.7022 58.0931C97.9827 61.8235 96.2858 64.6508 92.9701 66.3715C92.282 63.7444 95.2923 59.3026 98.7022 58.0931Z"
          fill="#3393FF"
        />
        <Path
          d="M92.6845 63.0565C90.5053 60.9352 89.0258 56.88 90.4033 53.4961C92.7755 55.4575 93.907 60.4948 92.6845 63.0565Z"
          fill="#3393FF"
        />
        <Path
          d="M84.3335 78.1259C83.3382 74.8256 85.1468 69.304 87.5819 69.4767C87.0117 72.511 87.4452 75.8861 84.3335 78.1259Z"
          fill="#3393FF"
        />
        <Path
          d="M87.7313 46.8731C90.5709 47.8879 93.912 51.776 92.8419 53.8649C89.8537 52.3112 87.354 48.893 87.7313 46.8731Z"
          fill="#3393FF"
        />
        <Path
          d="M94.8299 46.0631C96.321 48.4637 96.9481 53.0391 94.8676 54.9605C93.4394 53.095 93.388 48.3595 94.8299 46.0631Z"
          fill="#3393FF"
        />
        <Path
          d="M94.4414 60.8742C93.385 58.6678 94.5822 55.8161 97.8944 52.6846C98.736 56.3496 96.356 58.4858 94.4414 60.8742Z"
          fill="#3393FF"
        />
        <Path
          d="M92.7432 49.3011C90.8944 46.8623 90.6392 43.2942 92.1551 41.713C93.6006 43.4844 93.9508 47.6152 92.7432 49.3011Z"
          fill="#3393FF"
        />
        <Path
          d="M90.2515 44.6644C87.7968 43.9152 85.8444 40.0014 87.488 38.5239C88.89 40.3641 90.6494 42.0031 90.2515 44.6644Z"
          fill="#3393FF"
        />
        <Path
          d="M83.4224 80.4946C84.8253 80.5786 86.1201 80.6639 87.0318 81.8852C85.7492 82.6538 84.3369 82.127 83.4224 80.4946Z"
          fill="#3393FF"
        />
        <Path
          d="M29.711 78.5331C33.4028 79.115 36.9212 81.0346 40.5585 78.5722C37.4816 75.9603 31.6097 75.9214 29.711 78.5331Z"
          fill="#3393FF"
        />
        <Path
          d="M27.1471 71.9961C29.1373 74.3366 34.6945 76.1195 36.7532 75.0729C34.6304 72.5697 28.9146 69.8841 27.1471 71.9961Z"
          fill="#3393FF"
        />
        <Path
          d="M27.3638 65.1144C29.392 67.9632 31.0143 71.1523 34.9264 72.0101C34.5142 68.4437 29.8448 64.1399 27.3638 65.1144Z"
          fill="#3393FF"
        />
        <Path
          d="M36.2332 71.9425C37.9448 68.8969 37.4465 64.5809 35.1405 62.0455C33.699 64.357 34.1919 69.2064 36.2332 71.9425Z"
          fill="#3393FF"
        />
        <Path
          d="M26.9784 58.0931C27.6979 61.8235 29.3949 64.6508 32.7105 66.3715C33.3987 63.7444 30.3883 59.3026 26.9784 58.0931Z"
          fill="#3393FF"
        />
        <Path
          d="M32.9962 63.0565C35.1753 60.9352 36.6549 56.88 35.2773 53.4961C32.9052 55.4575 31.7736 60.4948 32.9962 63.0565Z"
          fill="#3393FF"
        />
        <Path
          d="M41.3472 78.1259C42.3424 74.8256 40.5339 69.304 38.0988 69.4767C38.669 72.511 38.2355 75.8861 41.3472 78.1259Z"
          fill="#3393FF"
        />
        <Path
          d="M37.9494 46.8731C35.1097 47.8879 31.7687 51.776 32.8388 53.8649C35.827 52.3112 38.3267 48.893 37.9494 46.8731Z"
          fill="#3393FF"
        />
        <Path
          d="M30.8507 46.0631C29.3597 48.4637 28.7326 53.0391 30.8131 54.9605C32.2412 53.095 32.2927 48.3595 30.8507 46.0631Z"
          fill="#3393FF"
        />
        <Path
          d="M31.2393 60.8742C32.2957 58.6678 31.0985 55.8161 27.7863 52.6846C26.9447 56.3496 29.3246 58.4858 31.2393 60.8742Z"
          fill="#3393FF"
        />
        <Path
          d="M32.9374 49.3011C34.7863 46.8623 35.0415 43.2942 33.5255 41.713C32.08 43.4844 31.7299 47.6152 32.9374 49.3011Z"
          fill="#3393FF"
        />
        <Path
          d="M35.4292 44.6644C37.8839 43.9152 39.8363 40.0014 38.1927 38.5239C36.7907 40.3641 35.0312 42.0031 35.4292 44.6644Z"
          fill="#3393FF"
        />
        <Path
          d="M42.2583 80.4946C40.8554 80.5786 39.5605 80.6639 38.6488 81.8852C39.9314 82.6538 41.3438 82.127 42.2583 80.4946Z"
          fill="#3393FF"
        />
        <Path
          d="M48.2023 35.416H50.8903V37H46.1503V28.576H48.2023V35.416ZM53.921 30.22V31.924H56.669V33.508H53.921V35.356H57.029V37H51.869V28.576H57.029V30.22H53.921ZM66.2692 28.576L63.2812 37H60.7132L57.7252 28.576H59.9092L61.9972 34.936L64.0972 28.576H66.2692ZM69.1788 30.22V31.924H71.9268V33.508H69.1788V35.356H72.2868V37H67.1268V28.576H72.2868V30.22H69.1788ZM75.671 35.416H78.359V37H73.619V28.576H75.671V35.416Z"
          fill="white"
        />
      </G>
      <Defs>
        <LinearGradient
          id="paint0_linear_2_13911"
          x1="32.5998"
          y1="115.937"
          x2="92.3962"
          y2="8.06161"
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#EDBC07" />
          <Stop offset="0.02" stopColor="#EEBE0F" />
          <Stop offset="0.16" stopColor="#F4CB36" />
          <Stop offset="0.28" stopColor="#F8D452" />
          <Stop offset="0.39" stopColor="#FBD963" />
          <Stop offset="0.47" stopColor="#FCDB69" />
          <Stop offset="1" stopColor="#A88711" />
        </LinearGradient>
        <LinearGradient
          id="paint1_linear_2_13911"
          x1="90.5"
          y1="14.4999"
          x2="29"
          y2="102.5"
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#C9A834" />
          <Stop offset="0.51668" stopColor="#F0CF5C" />
          <Stop offset="1" stopColor="#CEAB2D" />
        </LinearGradient>
        <LinearGradient
          id="paint2_linear_2_13911"
          x1="102.074"
          y1="27.5787"
          x2="22.9307"
          y2="96.4018"
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#EDBC07" />
          <Stop offset="0.02" stopColor="#EEBE0F" />
          <Stop offset="0.16" stopColor="#F4CB36" />
          <Stop offset="0.28" stopColor="#F8D452" />
          <Stop offset="0.39" stopColor="#FBD963" />
          <Stop offset="0.47" stopColor="#FCDB69" />
          <Stop offset="0.6" stopColor="#F9D866" />
          <Stop offset="0.71" stopColor="#EFCE5B" />
          <Stop offset="0.81" stopColor="#DDBC49" />
          <Stop offset="0.91" stopColor="#C6A530" />
          <Stop offset="1" stopColor="#A88711" />
        </LinearGradient>
        <LinearGradient
          id="paint3_linear_2_13911"
          x1="16.7787"
          y1="61.0433"
          x2="108.277"
          y2="62.9403"
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#0078FF" />
          <Stop offset="1" stopColor="#0060CC" />
        </LinearGradient>
        <LinearGradient
          id="paint4_linear_2_13911"
          x1="59.0662"
          y1="108.643"
          x2="62.6447"
          y2="94.5715"
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#A88711" />
          <Stop offset="0.46" stopColor="#EDBC07" />
          <Stop offset="0.48" stopColor="#EEBE0F" />
          <Stop offset="0.64" stopColor="#F4CB36" />
          <Stop offset="0.78" stopColor="#F8D452" />
          <Stop offset="0.91" stopColor="#FBD963" />
          <Stop offset="1" stopColor="#FCDB69" />
        </LinearGradient>
        <ClipPath id="clip0_2_13911">
          <Rect
            width="124"
            height="124"
            fill="white"
            transform="translate(0.5)"
          />
        </ClipPath>
      </Defs>
    </Svg>
  );
};
